import { createIcon } from '@chakra-ui/react';

export const PaymentBoldIcon = createIcon({
  displayName: 'PaymentBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M14.6663 14.6667C14.6663 14.94 14.4397 15.1667 14.1663 15.1667H1.83301C1.55967 15.1667 1.33301 14.94 1.33301 14.6667C1.33301 14.3934 1.55967 14.1667 1.83301 14.1667H14.1663C14.4397 14.1667 14.6663 14.3934 14.6663 14.6667Z"
          fill="#2B2448"
        />
        <path
          d="M10.2596 3.51336L3.09964 10.6734C2.8263 10.9467 2.3863 10.9467 2.11964 10.6734H2.11297C1.1863 9.74003 1.1863 8.23336 2.11297 7.30669L6.87963 2.54003C7.81297 1.60669 9.31963 1.60669 10.253 2.54003C10.5263 2.80003 10.5263 3.24669 10.2596 3.51336Z"
          fill="#2B2448"
        />
        <path
          d="M13.8803 6.16002L11.847 4.12669C11.5736 3.85336 11.1336 3.85336 10.867 4.12669L3.70695 11.2867C3.43362 11.5534 3.43362 11.9934 3.70695 12.2667L5.74029 14.3067C6.67362 15.2334 8.18029 15.2334 9.11362 14.3067L13.8736 9.54003C14.8203 8.60669 14.8203 7.09336 13.8803 6.16002ZM8.50695 12.18L7.70029 12.9934C7.53362 13.16 7.26029 13.16 7.08695 12.9934C6.92029 12.8267 6.92029 12.5534 7.08695 12.38L7.90029 11.5667C8.06029 11.4067 8.34029 11.4067 8.50695 11.5667C8.67362 11.7334 8.67362 12.02 8.50695 12.18ZM11.1536 9.53336L9.52695 11.1667C9.36029 11.3267 9.08695 11.3267 8.91362 11.1667C8.74695 11 8.74695 10.7267 8.91362 10.5534L10.547 8.92002C10.707 8.76003 10.987 8.76003 11.1536 8.92002C11.3203 9.09336 11.3203 9.36669 11.1536 9.53336Z"
          fill="#2B2448"
        />
      </svg>
    </>
  ),
});
